import * as Types from '../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDatalakeQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  root?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetDatalakeQuery = {
  dataLakeQuery: Pick<Types.DataLakeQuery, 'id' | 'sql' | 'status' | 'kind' | 'metadata'> & {
    annotations?: Types.Maybe<Pick<Types.Annotations, 'visualize'>>;
    userConfig?: Types.Maybe<
      Pick<Types.QueryUserConfig, 'queryId'> & {
        chartProperties: Array<
          Pick<
            Types.QueryChartPropertyConfig,
            | 'order'
            | 'limit'
            | 'chartType'
            | 'propertyId'
            | 'colorHexes'
            | 'propertyPath'
            | 'sortDirection'
            | 'propertyTableName'
            | 'propertyDisplayName'
          >
        >;
        tableProperties: Array<
          Pick<
            Types.QueryTablePropertyConfig,
            'order' | 'propertyId' | 'propertyPath' | 'propertyTableName' | 'propertyDisplayName'
          >
        >;
      }
    >;
    children: Array<Pick<Types.DataLakeQuery, 'id' | 'kind'>>;
  };
};

export const GetDatalakeQueryDocument = gql`
  query GetDatalakeQuery($id: ID!, $root: Boolean) {
    dataLakeQuery(id: $id, root: $root) {
      annotations {
        visualize
      }
      id
      sql
      status
      kind
      metadata
      userConfig {
        queryId
        chartProperties {
          order
          limit
          chartType
          propertyId
          colorHexes
          propertyPath
          sortDirection
          propertyTableName
          propertyDisplayName
        }
        tableProperties {
          order
          propertyId
          propertyPath
          propertyTableName
          propertyDisplayName
        }
      }
      children {
        id
        kind
      }
    }
  }
`;

/**
 * __useGetDatalakeQuery__
 *
 * To run a query within a React component, call `useGetDatalakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatalakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatalakeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      root: // value for 'root'
 *   },
 * });
 */
export function useGetDatalakeQuery(
  baseOptions: Apollo.QueryHookOptions<GetDatalakeQuery, GetDatalakeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDatalakeQuery, GetDatalakeQueryVariables>(
    GetDatalakeQueryDocument,
    options,
  );
}
export function useGetDatalakeQueryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDatalakeQuery, GetDatalakeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDatalakeQuery, GetDatalakeQueryVariables>(
    GetDatalakeQueryDocument,
    options,
  );
}
export function useGetDatalakeQuerySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDatalakeQuery, GetDatalakeQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDatalakeQuery, GetDatalakeQueryVariables>(
    GetDatalakeQueryDocument,
    options,
  );
}
export type GetDatalakeQueryHookResult = ReturnType<typeof useGetDatalakeQuery>;
export type GetDatalakeQueryLazyQueryHookResult = ReturnType<typeof useGetDatalakeQueryLazyQuery>;
export type GetDatalakeQuerySuspenseQueryHookResult = ReturnType<
  typeof useGetDatalakeQuerySuspenseQuery
>;
export type GetDatalakeQueryQueryResult = Apollo.QueryResult<
  GetDatalakeQuery,
  GetDatalakeQueryVariables
>;
export function mockGetDatalakeQuery({
  data,
  variables,
  errors,
}: {
  data: GetDatalakeQuery;
  variables?: GetDatalakeQueryVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetDatalakeQueryDocument, variables },
    result: { data, errors },
  };
}
